import React, { useRef, useState } from "react";
import { AccountBalance, Send } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { Box, Typography, Alert, Snackbar } from '@mui/material';
import HeaderCustom from "../../components/header/HeaderCustom";
import { LogoSicoop } from "../../components/logos/LogoImg";
import NumberCustomSinFormat from "../../components/numberCustom/NumberCustomSinFormat";
import NumberFormatCustom from "../../components/numberCustom/NumberFormatCustom";
import { ButtonStyleAzul, ButtonStyleWhite, CssTextField, DivBackgroundDasboard, DivHorizontal, MaxDiv, TypographyStyleGris, TypographyStyleSecundary } from "../../styles/Styles";
import SplashLoading from "../../components/splashLoading/SplashLoading";
import QrComponents from "../../components/Qr/QrComponents";
import { useNavigate } from "react-router-dom";
import { postGenerarQr } from "../../api/Api";
import sicoopQrLogo from "../../assets/logo-sicoop-qr.png";
import logoSip from "../../assets/logo_sip.png";

function DashboardHome() {
    const [monto, setMonto] = useState('');
    const [cuotas, setCuotas] = useState('1');
    const [cargando, setCargando] = useState(false);
    const [dataQr, setDataQr] = useState(null);
    const [qrHubActual, setQrHubActual] = useState(false);
    const [stateModal, setStateModal] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [mensaje, setMensaje] = useState('');
    const [openAlert, setOpenAlert] = useState(false);

    let history = useNavigate();

    const stateToken = useSelector(state => state.reducerGlobal.token);

    const handleValidarButtonQr = () => {
        //si la cuota es mayor de 36 se queda deshabilitado el boton, tiene que ser el monto mayor a 0
        if (monto === '' || cuotas === '' || cuotas > 36 || monto < 1) {
            return true;
        } else {
            return false;
        }
    }

    const handleVAlidarButtonCuenta = () => {
        //si la cuota es mayor a 1 se queda deshabilitado el boton, y si el monto es menor a 1==> solo se permite 1 cuota
        if (monto === '' || cuotas === '' || cuotas > 1 || monto < 1) {
            return true;
        } else {
            return false;
        }
    }

    const handleGenararQr = (qrHub) => {
        setQrHubActual(qrHub);
        const parseIdOperacion = () => {
            let idOperacion = stateToken.codeComercio;
            // Generar la fecha en formato YYMMDD
            const date = new Date();
            const formattedDate = date
                .toISOString()
                .slice(2, 10)
                .replace(/-/g, '');

            // Generar el session id basado en el tiempo transcurrido en el día
            const time = new Date();
            const millis = time.getTime() % 1_000_000;
            // Asegurar que el sessionId tiene longitud 8
            const sessionId = millis.toString().padStart(8, '0');

            return idOperacion + formattedDate + sessionId;
        }



        let data = {};
        //agregar decimal al monto usando expresiones regulares
        data.importe = monto.replace(/\./g, '') + '00';
        data.cuotas = cuotas;
        data.codComercio = stateToken.codeComercio;
        data.docUsuario = stateToken.usuarioDocumento;
        //fecha de vencimiento es, la fecha actual + 10 años
        let fecha = new Date();
        fecha.setFullYear(fecha.getFullYear() + 10);
        //se agrega 0 al dia y mes si es menor a 10
        data.fechaVencimiento = fecha.getDate() + '-' + (fecha.getMonth() + 1) + '-' + fecha.getFullYear();
        if (fecha.getDate() < 10) {
            data.fechaVencimiento = '0' + fecha.getDate() + '-' + (fecha.getMonth() + 1) + '-' + fecha.getFullYear();
        }
        if ((fecha.getMonth() + 1) < 10) {
            data.fechaVencimiento = fecha.getDate() + '-0' + (fecha.getMonth() + 1) + '-' + fecha.getFullYear();
        }
        if ((fecha.getMonth() + 1) < 10 && fecha.getDate() < 10) {
            data.fechaVencimiento = '0' + fecha.getDate() + '-0' + (fecha.getMonth() + 1) + '-' + fecha.getFullYear();
        }

        data.glosa = 'glosa';
        //reemplazar CTA. que esta al inicio de stateToken.cuentaAbono usando expresiones regulares
        data.ruc = stateToken.cuentaAbono.replace(/CTA./g, '');
        data.usoUnico = true;
        data.codOperacion = "COMP";
        data.idOperacionCaja = parseIdOperacion();
        data.tipoQr = 'DINAMICO';
        data.info = null;
        data.qrHub = qrHub;



        console.log("data==>Qr", data);

        setCargando(true);

        //se llama al servicio de generar qr
        postGenerarQr(data)
            .then((response) => {
                console.log("response", response);
                //valido que el header.codRespuesta sea 0 y data.codRespuesta sea 0
                if (response.header.codRespuesta === '0' && response.data.codRespuesta === '0') {
                    setDataQr(response.data);
                    setCargando(false);
                    setStateModal(true);
                } else {
                    setSeverity('warning');
                    setMensaje(response.header.txtRespuesta);
                    setOpenAlert(true);
                    setCargando(false);
                }
            })
            .catch((error) => {
                console.log("error", error);
                setCargando(false);
            })

    }

    const handleCargarCuenta = () => {
        let data = {};
        data.monto = monto;
        data.cuotas = cuotas;
        console.log("data", data);

        history('/home/payment', { state: data });
    }

    const handleCancelarQr = () => {
        setMonto('');
        setCuotas('1');
        setDataQr(null);
        setStateModal(false);
    }

    const handleCuotas = (e) => {
        //solo se admiten hasta 36 cuotas, si se ingresa mas de 36 se manda un alert
        if (e.target.value > 36) {
            setSeverity('warning');
            setMensaje('Solo se admiten hasta 36 cuotas');
            setOpenAlert(true);
            setCuotas(e.target.value);
        } else {
            setCuotas(e.target.value);
        }
    }

    const handleCloseAlert = () => {
        setOpenAlert(false);
    }

    return (
        <div>
            <HeaderCustom title="Sicoop Comercios">
                <div style={{
                }}>
                    <div style={{
                        alignContent: 'center',
                        justifyContent: 'center',
                        display: 'flex',

                    }}>
                        <LogoSicoop tamano={250} />
                    </div>

                    <MaxDiv>

                        <TypographyStyleSecundary variant="h5" component="h2" align="center" sx={{ padding: '5px' }}>
                            Ingrese el monto
                        </TypographyStyleSecundary>

                        <CssTextField
                            id="outlined-basic"
                            variant="outlined"
                            fullWidth
                            placeholder="Monto"
                            size="small"
                            value={monto}
                            onChange={(e) => setMonto(e.target.value)}
                            InputProps={
                                {
                                    inputComponent: NumberFormatCustom,
                                }
                            }

                        />

                        <TypographyStyleGris variant="h5" component="h2" align="center" sx={{ padding: '5px', marginBottom: '10px' }}>
                            Guaranies
                        </TypographyStyleGris>


                        <DivHorizontal>
                            <div style={{ width: '50%' }}>
                                <TypographyStyleSecundary variant="h5" component="h2" align="center" sx={{ padding: '5px' }}>
                                    Cuotas
                                </TypographyStyleSecundary>
                            </div>


                            <div style={{ width: '50%' }}>
                                <CssTextField
                                    id="outlined-basic-cuotas"
                                    variant="outlined"
                                    size="small"
                                    value={cuotas}
                                    // onChange={(e) => setCuotas(e.target.value)}
                                    onChange={handleCuotas}
                                    InputProps={
                                        {
                                            inputComponent: NumberCustomSinFormat,
                                        }
                                    }
                                />
                            </div>

                        </DivHorizontal>

                        <DivHorizontal style={{ gap: '10px', marginTop: '8px' }}>
                            <ButtonStyleWhite
                                variant="contained"
                                style={{
                                    flex: 1,
                                    aspectRatio: '1 / 1',
                                    borderRadius: '10px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px',
                                }}
                                disabled={handleValidarButtonQr()}
                                onClick={() => handleGenararQr(false)}
                            >
                                <img
                                    src={sicoopQrLogo}
                                    alt="Sicoop QR"
                                    style={{ width: '50%', maxHeight: '55%', objectFit: 'contain' }}
                                />
                                Sicoop QR
                            </ButtonStyleWhite>

                            <ButtonStyleWhite
                                variant="contained"
                                style={{
                                    flex: 1,
                                    aspectRatio: '1 / 1',
                                    borderRadius: '10px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px',
                                }}
                                disabled={handleValidarButtonQr()}
                                onClick={() => handleGenararQr(true)}
                            >
                                <img
                                    src={logoSip}
                                    alt="SIP"
                                    style={{ width: '50%', maxHeight: '55%', objectFit: 'contain' }}
                                />
                                SIP
                            </ButtonStyleWhite>
                        </DivHorizontal>

                        <Box sx={{}} mt={1}>
                            <ButtonStyleAzul
                                variant="contained"
                                style={{
                                    width: '100%',
                                    height: '50px',
                                    borderRadius: '10px'
                                }}
                                startIcon={<AccountBalance />}
                                disabled={handleVAlidarButtonCuenta()}
                                onClick={handleCargarCuenta}
                            >
                                Pago por Transferencia
                            </ButtonStyleAzul>

                            <TypographyStyleGris variant="subtitle1" gutterBottom align="center" sx={{ }}>
                                El monto limite para pago por transferencia es de 5.000.000 Gs.
                            </TypographyStyleGris>
                        </Box>



                        {dataQr &&
                            <QrComponents
                                dataQr={dataQr}
                                monto={monto}
                                qrHub={qrHubActual}
                                handleCancelarQr={handleCancelarQr}
                                dataUser={stateToken ? stateToken.descripcion : null}
                                open={stateModal}
                                setSeverity={setSeverity}
                                setMensaje={setMensaje}
                                setOpenAlert={setOpenAlert}
                            />
                        }
                    </MaxDiv>
                </div>

                {cargando && <SplashLoading cargando={cargando} />}

                <Snackbar open={openAlert} autoHideDuration={10000} onClose={handleCloseAlert}>
                    <Alert
                        onClose={handleCloseAlert}
                        severity={severity}
                        elevation={6}
                    // variant="filled"
                    >
                        {mensaje}
                    </Alert>
                </Snackbar>
            </HeaderCustom>
        </div>
    );
}

export default DashboardHome;